import React from 'react';
import PropTypes from 'prop-types';
import { registerField } from 'core/forms';
import { AnimatePresence, motion } from 'framer-motion';

import styles from '../styles/formFieldToggle.module.scss';
import FormFieldToggleItem from './formFieldToggleItem';

const FormFieldToggle = ({
  schema = {
    toggleData: {
      fieldValue: '',
      helperText: '',
      isSubToggle: false,
      parentId: null,
      subToggles: [],
      title: '',
      toggleValue: false,
    },
  },
  updateField = () => {},
  value = false,
}) => {
  const {
    toggleValue, title, parentId, fieldValue, subToggles, helperText, isSubToggle,
  } = schema.toggleData;

  const renderSubToggles = () => {
    if (!subToggles) return;
    if (toggleValue === true) {
      return (
        <motion.div
          key={`${parentId}-sub-toggle-${fieldValue}`}
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          transition={{ duration: 0.5 }}
          exit={{ opacity: 0, height: 0 }}
        >
          { subToggles?.map((toggle) => (
            <FormFieldToggleItem
              key={toggle.field}
              toggleId={`${toggle.parentId}-${toggle.field}-toggle`}
              value={toggle.value}
              helperText={toggle.helperText}
              title={toggle.label}
              fieldValue={toggle.field}
              onHandleChange={updateField}
              parentId={toggle.parentId}
              isSubToggle
            />
          ))}
        </motion.div>
      );
    }
  };
  return (
    <div className={styles.element}>
      <FormFieldToggleItem
        key={fieldValue}
        toggleId={`${parentId}-${fieldValue}-toggle`}
        value={!value ? toggleValue : value}
        helperText={helperText}
        title={title}
        fieldValue={fieldValue}
        onHandleChange={updateField}
        parentId={parentId}
        isSubToggle={isSubToggle}
      />
      <AnimatePresence exitBeforeEnter>
        {renderSubToggles()}
      </AnimatePresence>
    </div>
  );
};

FormFieldToggle.propTypes = {
  schema: PropTypes.shape({
    toggleData: PropTypes.shape({
      toggleValue: PropTypes.bool,
      title: PropTypes.string,
      parentId: PropTypes.number,
      fieldValue: PropTypes.string,
      subToggles: PropTypes.arrayOf(PropTypes.shape({})),
      helperText: PropTypes.string,
      isSubToggle: PropTypes.bool,
    }),
    value: PropTypes.bool,
    updateField: PropTypes.func,
  }),
};

registerField('Toggle', React.memo(FormFieldToggle));

export default FormFieldToggle;
